import React, { useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchFacets, SearchReset } from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_NORMAL } from '../../../config/constants';
import { facetAttributes } from '../config';

import SearchFacetRefinementCheckboxes from '../../SearchKit/SearchFacetRefinementCheckboxes';
import Button from '../../Button';
import './style.scss';
import FacetsDialog from '../../SearchKit/FacetsDialog';

const Facets: React.FC = () => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const enableShowMore = useMemo(() => width >= SCREEN_NORMAL, [width]);

  return (
    <>
      {facetAttributes.map((facetAttribute) => {
        const attribute = typeof facetAttribute === 'object' ? facetAttribute.attribute : facetAttribute;

        // The website filters are placed elsewhere.
        if (attribute === 'website_filter') {
          return null;
        }

        return (
          <SearchFacetRefinementCheckboxes
            key={attribute}
            attribute={attribute}
            sortBy={['name:asc']}
            showMore={enableShowMore}
            // If we don't have showMore enabled we want to render "all" the items.
            // Though we can't actually set it to show all, so 9999 will have to do.
            limit={enableShowMore ? 10 : 9999}
            // Also if we do actually use the showMore feature, there is also no way
            // to show all items after clicking the show more button. So also here;
            // 9999 will have to do.
            showMoreLimit={9999}
            showLessText={t('searchkit.vacancies.filter_show_less')}
            showMoreText={t('searchkit.vacancies.filter_show_more')}
          />
        );
      })}
    </>
  );
};

const SearchVacanciesFacets: React.FC<SearchFacetsProps> = (props) => {
  const { className, ...restProps } = props;

  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const renderAsDialog = useMemo(() => width < SCREEN_NORMAL, [width]);

  const classNames = c('SearchVacancies__Facets', className);

  return (
    <SearchFacets {...restProps} className={classNames}>
      {renderAsDialog ? (
        <FacetsDialog>
          <Facets />
        </FacetsDialog>
      ) : (
        <>
          <div className="SearchVacancies__Facets__Title d-flex align-items-center">
            <h4 className="mb-0">{t('searchkit.vacancies.filter_title')}</h4>
            <SearchReset
              buttonText={t('searchkit.vacancies.filter_reset')}
              // @ts-ignore
              button={Button}
              className="ml-auto"
              type="link"
            />
          </div>
          <Facets />
        </>
      )}
    </SearchFacets>
  );
};

export default SearchVacanciesFacets;
